export default {
  title: 'Creador de Planes IA',
  greeting: '¡Hola! Estoy aquí para ayudarte a crear una Optimización de Plan. ¿Qué necesitas?',
  describeRequirements: 'Describe tus requisitos',
  enterRequirements: 'Ingresa tus requisitos aquí...',
  next: 'Siguiente'
}
